<template>
  <div class="footer">
    <div class="container flex">
      <div class="menu-wrap flex">
        <div class="menu">
          <div class="title">{{column[7].title}}</div>
          <div class="list">
            <div><router-link to="/about/1">{{ column[8].title }}</router-link></div>
            <div><router-link to="/about/2">{{ column[9].title }}</router-link></div>
            <div><router-link to="/about/3">{{ column[10].title }}</router-link></div>
<!--            <div><router-link to="/about/4">{{ $t('nav.about.submenu.Honor') }}</router-link></div>-->
<!--            <div><router-link to="/about/5">{{ $t('nav.about.submenu.History') }}</router-link></div>-->
          </div>
        </div>
        <div class="menu">
          <div class="title">{{column[12].title}}</div>
          <div class="list">
            <div><router-link to="/Research/1">{{column[13].title}}</router-link></div>
            <div><router-link to="/Research/3">{{column[15].title}}</router-link></div>
            <div><router-link to="/Research/4">{{column[16].title}}</router-link></div>
          </div>
        </div>
        <div class="menu">
          <div class="title">PRODUCTS</div>
          <div class="list">
            <div v-for="type in pro_type" :key="type.id"><router-link :to="'/products/'+type.id">{{ type.title }}</router-link></div>
          </div>
        </div>
<!--        <div class="menu">-->
<!--          <div class="title">{{ $t('nav.news') }}</div>-->
<!--          <div class="list">-->
<!--            <div v-for="type in newsMenu" :key="type.ID"><router-link :to="'/news/'+type.ID">{{ type.CALLED }}</router-link></div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="menu">-->
<!--          <div class="title">{{ $t('nav.job') }}</div>-->
<!--          <div class="list">-->
<!--            <div><router-link to="/job">{{ $t('nav.job2') }}</router-link></div>-->
<!--          </div>-->
<!--        </div>-->
        <div class="menu">
          <div class="title">{{column[17].title}}</div>
          <div class="list">
            <div><router-link to="/contact">CONTACT INFORMATION</router-link></div>
          </div>
        </div>
      </div>
      <div class="info">
        <div class="follow">
          <div class="title">Follow Us</div>
          <div class="link">
            <a href="https://www.linkedin.com/company/81959849/admin/" target="_blank"><i class="fa fa-linkedin"></i></a>
            <a href="https://www.facebook.com/NingboFunjoy" target="_blank"><i class="fa fa-facebook"></i></a>
          </div>
        </div>
        <div class="hotline">
          <div class="title" style="text-transform: uppercase">Service Hotline</div>
            <input type="email" placeholder="Enter your email address" name="email" @keydown.enter="submit()" v-model="message">
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="container flex flex-space-between flex-wrap">
        <div class="left flex flex-wrap">
          <div class="link flex">
            <router-link to="/contact">Contact Us</router-link>
          </div>
          <div class="copyright">Ningbo Funjoy Technology Co., Ltd 浙1CP备2022015639号-1<a href="https://beian.miit.gov.cn/" target="_blank"> </a></div>
        </div>
        <div class="right flex flex-wrap">
          <div class="link">Design By：<a href="https://www.seniorweb.cn/" target="_blank">Senior Web</a></div>
          <div class="copyright-en"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get_column } from '@/util/lang.js'
import { mapState } from 'vuex'
import { pro_type } from '@/util/lang.js'
import { message } from '@/util/lang.js'
export default {
  data(){
    return{
      message:'',
      column: '',
      pro_type :'',
      typeID: {
        law: {
          en: '47',
          'zh-CN': '46'
        },
        copyright: {
          en: '49',
          'zh-CN': '48'
        }
      }
    }
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      langProducttype: state => state.langProducttype,
      langNewtype: state => state.langNewtype
    }),
    productMenu () {
      return this.langProducttype[this.lang]
    },
    newsMenu () {
      return this.langNewtype[this.lang]
    },
    getLawID(){
      return this.typeID.law[this.lang]
    },
    getCopyrightID(){
      return this.typeID.copyright[this.lang]
    }
  },
  methods: {
    fetchData () {
      const url = pro_type();
      this.$$axios.get(url).then(res => {
        this.pro_type = res.data
      })
      const url2= get_column();

      this.$$axios.get(url2).then(res => {
        this.column = res.data
        this.title.en = this.column[10].title

      })
    },
    submit(){
      const url = message(this.message);
      this.$$axios.get(url).then(res => {
        if (res.data.status) {
          this.$alert(res.data.message, 'Point Out', {
            confirmButtonText: 'Sure',
          })
        }

      })

    }
  },
  created() {
    this.fetchData()
  }
}
</script>

<style scoped>
.footer{
  background-color: #3a3a3a;
}
.footer .container{
  max-width: 1500px;
  margin: 0 auto;
}
.footer .container .menu-wrap{
  flex: auto;
  padding: 50px 0;
}
.footer .container .menu-wrap .menu{
  width: 16.66%;
}
.footer .container .menu-wrap .menu:nth-child(2) {
  width: 21%;
}
.footer .container .menu-wrap .menu .title{
  font-size: 16px;
  color: #fff;
}
.footer .container .menu-wrap .menu .list{
  margin-top: 15px;
}
.footer .container .menu-wrap .menu .list a{
  font-size: 12px;
  color: #a1a1a1;
  line-height: 35px;
  transition: 1s;
}
.footer .container .menu-wrap .menu .list a:hover{
  color: #fff;
}
.footer .container .info{
  background-color: #323232;
  width: 420px;
  padding: 25px;
}
.footer .container .info .follow{
  padding: 30px 0 20px;
  border-bottom: 1px solid #474747;
}
.footer .container .info .follow .title{
  font-family: "DINEngschrift";
  font-size: 30px;
  color: #fff;
  text-transform: uppercase;
}
.footer .container .info .follow .link{
  margin-top: 20px;
}
.footer .container .info .follow .link a{
  display: inline-block;
  width: 60px;
  height: 60px;
  font-size: 30px;
  color: #004b94;
  background-color: #373839;
  text-align: center;
  border-radius: 50%;
  margin-right: 25px;
  position: relative;
  transition: .3s;
  padding-top: 15px;
  padding-bottom: 15px;
}
.footer .container .info .follow .link a:hover{
  color: #fff;
  background-color: #004b94;
}
.footer .container .info .follow .link a i{
  background-color: transparent;
  width: 30px;
  transition: .3s;
  border-radius: 50%;
  box-sizing: content-box;
}
.footer .container .info .follow .link a:hover i{
  background-color: #373839;
  padding: 10px;
  margin-top: -10px;
}
.footer .container .info .hotline{
  padding-top: 20px;
}
.footer .container .info .hotline .title{
  font-family: "DINEngschrift";
  font-size: 18px;
  color: #848484;
}
.footer .container .info .hotline input{
  background-color: #474747;
  border: 0;
  padding: 12px 20px;
  margin-top: 20px;
  color: #fff;
  width: 100%;
  font-family: auto;
}
.footer .container .info .hotline input::placeholder {
  font-family: auto;
  text-transform: uppercase;
}
.footer .bottom{
  background-color: #323232;
  padding: 35px 0;
  font-size: 14px;
  color: #969696;
}
.footer .bottom .link{
  margin-right: 20px;
}
.footer .bottom a{
  color: #969696;
  transition: 1s;
}
.footer .bottom .link span{
  margin: 0 10px;
}
.footer .bottom a:hover{
  color: #fff;
}
.footer .bottom .right .link{
  /* margin-right: 20px; */
}
@media (max-width: 1500px){
  .footer .container {
    width: 90%;
  }
  .footer .container .menu-wrap .menu {
    width: 25%;
  }
}
@media (max-width: 768px){
  .footer{
    text-align: center;
  }
  .footer .container .menu-wrap{
    display: none;
  }
  .footer .container .info{
    width: 100%;
  }
  .footer .bottom{
    padding-left: 20px;
    padding-right: 20px;
  }
  .footer .bottom .left,
  .footer .bottom .right{
    width: 100%;
  }
  .footer .bottom .link{
    margin-right: 0;
    width: 100%;
    justify-content: center;
  }
  .footer .bottom .copyright{
    width: 100%;
    margin-top: 30px;
  }
  .footer .bottom .right .link{
    margin-top: 20px;
  }
  .footer .bottom .right .copyright-en{
    display: none;
  }
  .footer .container {
    width: 100%;
  }
}
</style>
